import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo ESL (electronic shelf label) connector: Komodo.SCM.Web/Controllers/Api/Esl/*.
const enc = encodeURIComponent;

const instances = () => Client.get('/api/esl-instance');
const createInstance = (dto) => Client.post('/api/esl-instance', dto);
const updateInstance = (code, dto) =>
	Client.put(`/api/esl-instance/${enc(code)}`, dto);
// EslInstanceOperation.InitProducts → queued count
const initProducts = (dto) =>
	Client.post('/api/esl-instance/InitEslProduct', dto);

// EslProductQuery { deptCode, sku, itemName } → PagerRecord<EslProductDTO>
const products = (query) =>
	Client.post('/api/esl-product/query-pager', {
		...PAGE_ALL,
		pageItems: 500,
		...(query || {}),
	}).then(pagerRows);
const updateProduct = (pid, dto) =>
	Client.put(`/api/esl-product/${enc(pid)}`, dto);
// EslProductQuery { deptCode, pids } → CommonActionResult
const publishProducts = (deptCode, pids) =>
	Client.post('/api/esl-product/publish-products', { deptCode, pids });

const records = (query) =>
	Client.post('/api/esl-record/query-pager', {
		...PAGE_ALL,
		pageItems: 500,
		...(query || {}),
	}).then(pagerRows);

export default {
	instances,
	createInstance,
	updateInstance,
	initProducts,
	products,
	updateProduct,
	publishProducts,
	records,
};
